module.exports = __webpack_public_path__ + "static/media/iStock-1285270580.4eeaac74.jpg";